package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AvailabilityRepository

class RemoveDayOffUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(dayOffId: String): Result<Unit> {
        return repository.removeDayOff(dayOffId)
    }
}
